import Vue from 'vue';
import dayjs from 'dayjs';
import { formatUser } from '~/utils/format-user'

window.dayjs = dayjs

const VueMask = () => import("v-mask");
Vue.use(VueMask);

import VModal from 'vue-js-modal'
Vue.use(VModal, { dialog: true })

const luxon = require("luxon");
window.luxon = luxon

function toFixed(num, fixed = 2) {
    let re = new RegExp('^-?\\d+(?:\.\\d{0,' + (fixed || -1) + '})?');
    return parseFloat(num.toString().match(re)[0]);
}
Vue.mixin({
    filters: {
        format_date: function () {
            return this.$store.state.settings.timezone;
        }
    },
    methods: {
        async openRegister() {
            if(this.$config.LOGIN_DISABLED) {
                this.$modal.show('modal-forbidden')
                return;
            }
            this.$modal.hide('modal-login')
            this.$modal.show('modal-registration')
        },
        async openForgotPassword() {
            this.$modal.hide('modal-login')
            this.$modal.show('modal-forgot-password')
        },
        async openResetPassword() {
            this.$modal.show('modal-reset-password')
        },
        async openCashierOld(page = "deposit") {
          this.$store.commit("openLeftSidebar", false);
          this.$store.commit("openRightSidebar", false);

          await this.refreshSession();

          if (!this.user) {
            await this.$router.push(this.localePath({path: "/"}));
          } else {
            if (this.cashierWindow && !this.cashierWindow.closed) {
              this.cashierWindow.close();
            }

            let gclid = this.$cookies.get("gclid");
            if (gclid === undefined || !gclid.match(/^[-_0-9a-zA-Z]+$/)) {
              gclid = "";
            }
            if (gclid) {
              if (page.indexOf("?") === -1) {
                page += "?" + "gclid=" + gclid;
              } else {
                page += "&" + "gclid=" + gclid;
              }
            }

            if(this.system === 'app') {
              let sportify_app = ''
              if (page.indexOf("?") === -1) {
                sportify_app = '?sportify_app=1'
              } else {
                sportify_app = '&sportify_app=1'
              }
              sendToWebView('open_cashier', {url: this.$config.CASHIER_URL + "/" + page + sportify_app})
              return;
            }
            this.cashierWindow = window.open(
              this.$config.CASHIER_URL + "/" + page,
              "_blank",
              "directories=no,titlebar=no,toolbar=no,location=no,status=no,menubar=no,scrollbars=no,resizable=no,width=800,height=600"
            );

            if (!this.cashierWindow) {
              window.location.href = this.$config.CASHIER_URL + "/" + page;
            }
          }
        },
        async openCashier(page = "deposit") {
            this.$store.commit("openLeftSidebar", false);
            this.$store.commit("openRightSidebar", false);

            await this.refreshSession();

            if (!this.user) {
                await this.$router.push(this.localePath({ path: "/" }));
                return;
            }

            let gclid = this.$cookies.get("gclid");
            if (gclid === undefined || !gclid.match(/^[-_0-9a-zA-Z]+$/)) {
                gclid = "";
            }
            if (gclid) {
                page += (page.indexOf("?") === -1 ? "?" : "&") + "gclid=" + gclid;
            }

            const cashierUrl = this.$config.CASHIER_URL + "/" + page;
            const userMode = _.get(this.user, 'cashier_mode');
            const cashierMode = userMode === 'iframe' || userMode === 'popup'
                ? userMode
                : this.$config.DEFAULT_CASHIER_MODE;
            const iframe = cashierMode === 'iframe';

            if (this.system === 'app') {
                const appUrl = cashierUrl + (page.indexOf("?") === -1 ? "?" : "&") + "sportify_app=1";
                if (!iframe) {
                    sendToWebView('open_cashier', { url: appUrl });
                    return;
                }
                this.$store.commit('openCashierOverlay', appUrl);
                return;
            }

            if (!iframe) {
                if (this.cashierWindow && !this.cashierWindow.closed) {
                    this.cashierWindow.close();
                }
                const width = Math.min(1024, window.screen.availWidth);
                const height = Math.min(768, window.screen.availHeight);
                const left = Math.max(0, (window.screen.availWidth - width) / 2);
                const top = Math.max(0, (window.screen.availHeight - height) / 2);
                this.cashierWindow = window.open(
                    cashierUrl,
                    "_blank",
                    `directories=no,titlebar=no,toolbar=no,location=no,status=no,menubar=no,scrollbars=yes,resizable=yes,width=${width},height=${height},left=${left},top=${top}`
                );
                if (!this.cashierWindow) {
                    window.location.href = cashierUrl;
                }
                return;
            }

            this.$store.commit('openCashierOverlay', cashierUrl)
        },
        async openCasino (page = '') {
            const url = this.$config.CASINO_API + '/' + page;
            if (typeof window.startNavProgress === 'function') window.startNavProgress();
            window.location.href = typeof window.markSwitchUrl === 'function' ? window.markSwitchUrl(url) : url;
        },
        async updateSession() {
          if(!this.user) {
            return
          }

          let bodyFormData = new FormData();
          bodyFormData.append('token', localStorage.login_token);

          const response = await axios({
            method: "post",
            withCredentials: true,
            url: this.$config.CASINO_API + '/register/cross_login',
            data: bodyFormData,
            headers: { "Content-Type": "multipart/form-data" },
          })

          this.$store.commit('auth/setSessionToken', _.get(response, 'data.session_id'))
          localStorage.setItem('session_token', _.get(response, 'data.session_id')); //save the jwt

        },
        async checkLogin() {
          console.log('checkLogin')

          try {
            let result = await this.$auth().get('/api/common/check-login', {})
            let data = _.get(result, 'data')
            console.log('checkLogin', data)
            if( _.get(data, 'result') ) {
              let user_info = this.format_user(_.get(data, 'userInfo'));
              if (user_info.require_verify === false) {
                user_info.balance = user_info.balance*100
                localStorage.setItem('jwt', _.get(data, 'jwt')); //save the jwt

                let domain = '.' + this.$config.DOMAIN;
                this.$cookies.set('jwt', _.get(data, 'jwt'), {
                  path: '/',
                  domain: domain,
                  secure: true
                })

                localStorage.setItem('login_token', _.get(data, 'userInfo.login_token')); //save the jwt
                window.loginToken = _.get(data, 'userInfo.login_token')
                this.$store.commit('auth/setLoginToken', _.get(data, 'userInfo.login_token'))
                this.$store.commit('auth/setJwt', _.get(data, 'jwt'))
                this.$store.commit('auth/storeUser', user_info)
              }

              if(this.system === 'app') {
                window.sendToWebView('sync_user', {data: _.get(data, 'userInfo')})
              }
            }

          } catch(e) {
            console.log('checkLogin', _.get(e, 'response.data'))
            if(_.has(e, 'response.data.result') && !_.get(e, 'response.data.result')) {
              //logout user
              localStorage.removeItem('jwt');
              localStorage.removeItem('login_token');
              let domain = '.' + this.$config.DOMAIN;
              this.$cookies.remove('jwt',{
                path: '/',
                domain: domain,
                secure: true
              });
              this.$store.commit('auth/clearAuthentication')
            }
          } finally {
            this.$store.commit('auth/setAuthReady', true)
          }
        },
        async getBalance() {
          if(!this.user) {
            return
          }
          let decoded = jwt_decode(this.jwt);
          if (Date.now() >= _.get(decoded, 'exp') * 1000) {
            return false;
          }
          if (_.get(decoded, 'aud') !== 'bet777es') {
            localStorage.setItem('jwt', null)
            this.$store.commit('auth/clearAuthentication')
            return false;
          }

          try {
            let result = await this.$api().get('/v1/player/details', {})
            let data = _.get(result, 'data')
            console.log('getBalance', data, _.get(data, 'data.balance'))
            this.$store.commit('auth/storeUser', {balance: _.get(data, 'data.balance')})
          } catch(e) {
            let data = _.get(e, 'response.data')
            console.log('get-balance', data)
          }
        },
        async refreshSession() {
            if (!this.user) {
                return
            }
            try {
                let response = await this.$auth().post('/api/common/refresh-session', {
                    session_id: this.sessionToken,
                })
                console.log('refreshSession', response)
            } catch (e) {
                if (e.response && !_.get(e.response, 'data.result')) {
                    console.log('The session has expired')
                    this.$store.commit('auth/clearAuthentication')
                    await this.$router.push(this.localePath({ path: '/' }))
                    window._alert(this.$t("You've been logged out for inactivity"))
                } else {
                    console.log('refreshSession failed without a response, ignoring', e)
                }
                return false
            }
        },
        openLogin: function (path = null) {
          this.$store.commit('setAuthRedirectTo', path)
          this.$store.commit('betslip/toggleBetslip', false)
          this.$store.commit('openLeftSidebar', false)
          this.$store.commit('openRightSidebar', false)
          this.$store.commit('betslip/toggleBetslip', false)

          if(this.system === 'app') {
            if (!this.user) {
              if(_.get(this.$store.state.mobile, 'loginMode') === 'auto' && _.get(this.$store.state.mobile, 'autologinPayload')) {
                this.$root.$emit('perform_auto_login');
              } else if(_.get(this.$store.state.mobile, 'loginMode') === 'biometric' && _.get(this.$store.state.mobile, 'autologinPayload')) {
                this.$root.$emit('perform_biometric_login');
              } else {
                this.$modal.show("modal-login");
              }
            }
          } else {
            if (!this.user) {
              this.$modal.show("modal-login");
            }
          }
        },
        loadGlobalIframe: function (page, params, silent = false) {
              if(page === 'hide_iframe') {
                  console.log('setIframePage', "")
              }
              if(page === 'open_page') {
                  console.log('setIframePage', _.get(params, 'url'))
              }
              console.log('global-iframe', { page: page, params: params, silent: silent })
              this.$root.$emit('global-iframe', { page: page, params: params, silent: silent })
          },
        formatDate: function (datetime, format) {
          return dayjs(datetime).tz(this.$store.state.settings.timezone).format(format)
        },
        fetchSports: async function () {
            try {
                const response = await this.$content().get('sports', {
                    params: { lang: this.lang, country: this.country, bookmaker: process.env.BOOKMAKER }
                })
                let sports = _.get(response, 'data.data', [])
                this.$store.commit('setSports', sports)
            } catch (e) {
                console.log(e)
            }
        },
        goBack: function () {
            if (window.history.length > 2) {
                this.$router.back();
            } else {
                this.$router.push(this.localePath({ path: '/' }))
            }
        },
        format_money: function (amount, currency = null) {
            if (!currency)
                currency = this.currency;
            if (_.isNaN(Number(amount))) {
                amount = 0;
            }

            // Create our number formatter.
            let formatter = new Intl.NumberFormat('es-ES', {
                style: 'currency',
                currency: currency,
            });

            let formatted = formatter.format(toFixed(amount / 100));
            formatted = formatted.replace(/(\d)(?=(\d{3})+,)/g, '$1.');

            return formatted;
        },

        format_user(response) {
            return formatUser(response)
        },
        format_user_update(response) {
            let auth = {
                id: _.get(response, 'user_id'),
                name: _.get(response, 'Account'),
                username: _.get(response, 'Account'),
                email: _.get(response, 'Email'),
                currency: "EUR",
                balance: parseFloat(_.get(response, 'Money', 0)) * 100,
            }
            if (_.has(auth, 'username')) {
                return auth;
            }
            return null;
        },
        alert: function (title, text, button, callback = null) {
            let buttons = [];
            if (button) {
                buttons.push({
                    title: button,
                    handler: (e) => {
                        console.log(e);
                        if (callback) {
                            callback(e);
                        }
                        this.$modal.hide('dialog')
                    }
                })
            }
            this.$modal.show('dialog', {
                title: title,
                text: text,
                buttons: buttons
            })
        },
        confirm: function (title, text, buttons) {
            this.$modal.show('dialog', {
                title: title,
                text: text,
                buttons: buttons
            })
        }
    }
})


import AspectRatio from 'v-aspect-ratio'
import jwt_decode from "jwt-decode";
Vue.use(AspectRatio)
